import { useCallback } from 'react';

import { useNavigation } from '@react-navigation/native';

import { useModals } from '@/feature/alerts/hooks/use-modals';

/**
 * Returns an opener for a specific Predictions legal document.
 */
export const useOpenPredictionDocLink = (onWebViewOpened?: () => void) => {
    const { navigate } = useNavigation();
    const { dismissAll } = useModals();

    return useCallback(
        (uri: string) => {
            if (!uri) {
                return;
            }
            dismissAll();
            onWebViewOpened?.();
            navigate('ModalWebView', { uri });
        },
        [dismissAll, navigate, onWebViewOpened]
    );
};
